module.exports = __webpack_public_path__ + "static/media/item_39_2.14f7b6c6.png";